define('modules/common/directive/CliensAvvisi',[], function() {
	var Directive = function() {

		return {
			restrict: 'A',
			/*scope: {

			},*/
			replace: true,
			templateUrl: 'avvisi/index.html?t=' + new Date().getTime(),
			scope: {},
			link: function(scope, elem, attrs) {}
		};

	};
	return [Directive];
});

